var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.642,
    height: 16.723,
    viewBox: "0 0 10.642 16.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone_iphone_FILL0_wght400_GRAD0_opsz48",
    d: "M15.321,17.3a.552.552,0,1,0-.409-.162A.554.554,0,0,0,15.321,17.3ZM11.14,14.732H19.5V4.85H11.14Zm0,3.991A1.169,1.169,0,0,1,10,17.582V3.14a1.094,1.094,0,0,1,.342-.8A1.094,1.094,0,0,1,11.14,2H19.5a1.094,1.094,0,0,1,.8.342,1.094,1.094,0,0,1,.342.8V17.582a1.169,1.169,0,0,1-1.14,1.14Zm0-15.012H19.5V3.14H11.14Zm0-.57h0v0Zm0,12.732v1.71H19.5v-1.71Zm0,1.71h0v0Z",
    transform: "translate(-10 -2)",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.96461acf24070d51309f9e9fa1e4ed67.svg";
export { ForwardRef as ReactComponent };